var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("ProgressCircular")
    : _c(
        "form",
        {
          attrs: { novalidate: "", disabled: _vm.disabled },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return (() => {}).apply(null, arguments)
            },
          },
        },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "8" } },
                [
                  _c(
                    "v-card",
                    {
                      attrs: {
                        "max-width": "1200px",
                        flat: "",
                        color: "transparent",
                      },
                    },
                    [
                      _c(
                        "v-card-title",
                        [
                          _c("FormHeader", {
                            attrs: {
                              loading: _vm.loading,
                              disabled: _vm.disabled,
                              link: "page-legal-details",
                              title: "Редактировать анкету юр. лица",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "PageContent",
                            { attrs: { height: "90" } },
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [
                                            _vm._v("Форма предприятия*"),
                                          ]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              id: "orgType",
                                              value: "",
                                              autofocus: !_vm.fields.orgType,
                                              "error-messages":
                                                _vm.validationErrors.orgType,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.$v.fields.orgType.$touch()
                                              },
                                            },
                                            model: {
                                              value: _vm.fields.orgType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "orgType",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.orgType",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [
                                            _vm._v("Название организации*"),
                                          ]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              id: "title",
                                              value: "",
                                              autofocus: !_vm.fields.title,
                                              "error-messages":
                                                _vm.validationErrors.title,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.$v.fields.title.$touch()
                                              },
                                            },
                                            model: {
                                              value: _vm.fields.title,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "title",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.title",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Фамилия*")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              id: "surname",
                                              value: "",
                                              autofocus: !_vm.fields.surname,
                                              "error-messages":
                                                _vm.validationErrors.surname,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.$v.fields.title.$touch()
                                              },
                                            },
                                            model: {
                                              value: _vm.fields.surname,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "surname",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.surname",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Имя*")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              value: "",
                                              id: "name",
                                              autofocus: !_vm.fields.name,
                                              "error-messages":
                                                _vm.validationErrors.name,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.$v.fields.name.$touch()
                                              },
                                            },
                                            model: {
                                              value: _vm.fields.name,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "name",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.name",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Отчество")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              value: "",
                                              autofocus: !_vm.fields.patronymic,
                                              "error-messages":
                                                _vm.validationErrors.patronymic,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            model: {
                                              value: _vm.fields.patronymic,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "patronymic",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.patronymic",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Должность")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              value: "",
                                              autofocus: !_vm.fields.position,
                                              "error-messages":
                                                _vm.validationErrors.position,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.$v.fields.position.$touch()
                                              },
                                            },
                                            model: {
                                              value: _vm.fields.position,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "position",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.position",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [
                                            _vm._v("Номер телефона для связи*"),
                                          ]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              id: "phone",
                                              value: "",
                                              autofocus: !_vm.fields.phone,
                                              "error-messages":
                                                _vm.validationErrors.phone,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.$v.fields.phone.$touch()
                                              },
                                            },
                                            model: {
                                              value: _vm.fields.phone,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "phone",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.phone",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Эл.почта*")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              id: "email",
                                              value: "",
                                              autofocus: !_vm.fields.email,
                                              "error-messages":
                                                _vm.validationErrors.email,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.$v.fields.email.$touch()
                                              },
                                            },
                                            model: {
                                              value: _vm.fields.email,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "email",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.email",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [
                                            _vm._v("ИНН организации*"),
                                          ]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              id: "inn",
                                              value: "",
                                              autofocus: !_vm.fields.inn,
                                              "error-messages":
                                                _vm.validationErrors.inn,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.$v.fields.inn.$touch()
                                              },
                                            },
                                            model: {
                                              value: _vm.fields.inn,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.fields, "inn", $$v)
                                              },
                                              expression: "fields.inn",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("ОГРН (ОГРНИП)")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              value: "",
                                              autofocus: !_vm.fields.ogrn,
                                              "error-messages":
                                                _vm.validationErrors.ogrn,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.$v.fields.ogrn.$touch()
                                              },
                                            },
                                            model: {
                                              value: _vm.fields.ogrn,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "ogrn",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.ogrn",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [
                                            _vm._v("Юридический адрес"),
                                          ]),
                                          _c("v-textarea", {
                                            attrs: {
                                              outlined: "",
                                              value: "",
                                              autofocus:
                                                !_vm.fields.legalAddress,
                                              "error-messages":
                                                _vm.validationErrors
                                                  .legalAddress,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            model: {
                                              value: _vm.fields.legalAddress,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "legalAddress",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.legalAddress",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [
                                            _vm._v("Почтовый адрес"),
                                          ]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              value: "",
                                              autofocus:
                                                !_vm.fields.mailAddress,
                                              "error-messages":
                                                _vm.validationErrors
                                                  .mailAddress,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            model: {
                                              value: _vm.fields.mailAddress,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "mailAddress",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.mailAddress",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Банк")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              value: "",
                                              autofocus: !_vm.fields.bank,
                                              "error-messages":
                                                _vm.validationErrors.bank,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            model: {
                                              value: _vm.fields.bank,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "bank",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.bank",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [
                                            _vm._v("Расчетный счет"),
                                          ]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              value: "",
                                              autofocus:
                                                !_vm.fields.checkingAcc,
                                              "error-messages":
                                                _vm.validationErrors
                                                  .checkingAcc,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.$v.fields.checkingAcc.$touch()
                                              },
                                            },
                                            model: {
                                              value: _vm.fields.checkingAcc,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "checkingAcc",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.checkingAcc",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("БИК банка")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              value: "",
                                              autofocus: !_vm.fields.bic,
                                              "error-messages":
                                                _vm.validationErrors.bic,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.$v.fields.bic.$touch()
                                              },
                                            },
                                            model: {
                                              value: _vm.fields.bic,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.fields, "bic", $$v)
                                              },
                                              expression: "fields.bic",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c("ManageSidePanel", {
                    ref: "manageSidePanel",
                    attrs: {
                      isLocales: false,
                      "is-new": false,
                      "created-at": _vm.data.createdAt,
                      "updated-at": _vm.data.updatedAt,
                      "is-loading": _vm.loading,
                      "is-submit-disabled": _vm.disabled,
                      "entity-id": _vm.data.id,
                      "entity-type": "legalDetail",
                    },
                    on: {
                      delete: function ($event) {
                        return _vm.$emit("delete-detail")
                      },
                      cancel: function ($event) {
                        return _vm.$router.push({ name: "page-legal-details" })
                      },
                      submit: _vm.submit,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }